import { useParams } from 'react-router-dom'
import { PramsKeys } from 'src/types/type'
import { useRecoilValue } from 'recoil'
import { uiFooterStyle } from 'src/recoil/common'
import { monitoredOpen } from 'src/service/utils/sentry/navigation'
import { Rop01FooterWrap } from 'src/styles/styledcomponent/views/Rop01/Footer'

const Footer = (): JSX.Element => {
  const { pcode } = useParams<PramsKeys>()
  const { color, backgroundColor } = useRecoilValue(uiFooterStyle)
  const homepage = (): void => {
    monitoredOpen('https://www.familycare.ai/', 'homepage', '_blank')
  }
  const committee = (): void => {
    monitoredOpen('http://www.ftc.go.kr/www/bizCommList.do?key=232', 'committee', '_blank')
  }
  const pCodeLiContents = (pcode: string) => {
    switch (pcode) {
      case 'sktpass_01':
      case 'sktpass_02':
      case 'sktpass_03':
        return (
          <>
            <li>본 이벤트 및 휴대폰가족보호 서비스는 (주)데이터유니버스에서 제공합니다.</li>
            <li className="important">
              서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.
            </li>
            <li>미아/치매노인찾기 보상 보험은 가입 다음날 0시부터 제공되며, 미아찾기/치매노인찾기 각각 담보당 서비스 이용자 1인 1사고당 보험한도액은 200만원입니다. 보험금 지급 시 각 담보당 자기부담금(10만원)이 발생하며, 증권상 최대보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.</li>
            <li>
              본 서비스의 원활한 이용을 위해 앱을 설치해주세요.(스마트폰 안드로이드 7.0이상 지원)
            </li>
            <li>
              본 서비스는 청약철회가 불가능한 상품입니다.(전자상거래 등에서의 소비자보호에 관한 법률
              제17조 2항 5호에 따라 디지털 콘텐츠의 제공이 개시된 경우 청약철회를 제공하지
              않습니다.)
            </li>
            <li>
              본 이벤트는 만 20세 이상의 SKT 고객이 아니거나, 휴대폰 정지 혹은 이용중인 스마트폰
              OS에 따라 참여에 제한이 있을 수 있습니다.
            </li>
            <li>
              본 이벤트의 경품의 경우, 휴대폰가족보호 서비스에 유료로 신규 가입한 고객에 한하여
              지급됩니다.
            </li>
            <li>
              본 이벤트는 경품 추첨일 이전에 서비스를 해지하시는 경우 경품이 지급되지 않습니다.
            </li>
            <li>
              본 이벤트의 경품으로 지급된 쿠폰을 기한 내에 미등록하여 이용기한이 만료된 경우
              보상하지 않습니다.
            </li>
            <li>
              본 이벤트의 경품 중 모바일 쿠폰(이마트 금액권 3,000원권)의 경우, 추첨일 기준 가입
              유지자 전원에게 영업일 기준 3일 이내 휴대폰 번호로 문자 발송되며 운영사의 사정에 따라
              지연될 수 있습니다.
            </li>
            <li>
              본 이벤트의 경품 중 5만원 초과 경품의 경우 제세공과금 22%를 당첨자가 부담하며,
              재세공과금 처리를 위해 별도의 개인정보를 요청할 수 있습니다.
            </li>
            <li>
              본 이벤트의 경품 중 5만원 초과 경품의 경우, 추첨 후 7일간 총 3회의 전화 혹은 문자를
              통한 연락이 연결되지 않을 경우 당첨이 취소 처리되며, 재추첨은 이루어지지 않습니다.
            </li>
            <li>
              본 이벤트에 비정상적, 불법적인 방법으로 참여한 경우, 당첨자 선정에서 제외되거나 당첨이
              취소될 수 있습니다.
            </li>
            <li>본 이벤트는 운영사의 사정에 따라 별도 고지없이 변경 또는 중단될 수 있습니다.</li>
            <li>본 이벤트는 휴대폰번호 기준 1회만 참여 가능합니다.</li>
            <li>문의 : 고객센터 1855-3631, 이메일 cs@datau.co.kr</li>
            <li>서비스 홈페이지: https://www.familycare.ai</li>
            <li>(주)데이터유니버스 서울 영등포구 여의대로 70</li>
            <li>사업자등록번호: 382-86-1230 / 통신판매업신고: 제2020-서울영등포-1315호</li>
          </>
        )
      case 'snow_01':
        return (
          <>
            <li>본 이벤트 및 휴대폰가족보호 서비스는 (주)데이터유니버스에서 제공합니다.</li>
            <li className="important">
              서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.
            </li>
            <li>미아/치매노인찾기 보상 보험은 가입 다음날 0시부터 제공되며, 미아찾기/치매노인찾기 각각 담보당 서비스 이용자 1인 1사고당 보험한도액은 200만원입니다. 보험금 지급 시 각 담보당 자기부담금(10만원)이 발생하며, 증권상 최대보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.</li>
            <li>
              본 서비스의 원활한 이용을 위해 앱을 설치해주세요.(스마트폰 안드로이드 7.0이상 지원)
            </li>
            <li>
              본 서비스는 청약철회가 불가능한 상품입니다.(전자상거래 등에서의 소비자보호에 관한 법률
              제17조 2항 5호에 따라 디지털 콘텐츠의 제공이 개시된 경우 청약철회를 제공하지
              않습니다.)
            </li>
            <li>
              미성년자의 경우, 법정대리인 동의 없는 가입 시 미성년자 본인 또는 법정대리인이 계약을
              취소할 수 있습니다.
            </li>
            <li>
              본 이벤트는 만 20세 이상이 아니거나, 휴대폰 정지 혹은 이용중인 스마트폰 OS에 따라
              참여에 제한이 있을 수 있습니다.
            </li>
            <li>
              본 이벤트의 경품의 경우, 휴대폰가족보호 서비스에 유료로 신규 가입한 고객에 한하여
              지급됩니다.
            </li>
            <li>
              본 이벤트는 경품 추첨일 이전에 서비스를 해지하시는 경우 경품이 지급되지 않습니다.
            </li>
            <li>
              본 이벤트의 경품으로 지급된 쿠폰을 기한 내에 미등록하여 이용기한이 만료된 경우
              보상하지 않습니다.
            </li>
            <li>
              본 이벤트의 경품 중 스타벅스 아메리카노 기프티콘의 경우, 가입 후 1개월 유지자 전원
              에게 휴대폰 번호로 문자 발송되며 운영사의 사정에 따라 지연될 수 있습니다.
            </li>
            <li>
              본 이벤트에 비정상적, 불법적인 방법으로 참여한 경우, 당첨자 선정에서 제외되거나 당첨이
              취소될 수 있습니다.
            </li>
            <li>본 이벤트는 운영사의 사정에 따라 별도 고지없이 변경 또는 중단될 수 있습니다.</li>
            <li>본 이벤트는 휴대폰번호 기준 1회만 참여 가능합니다.</li>
            <li>
              문의 : 고객센터 <a href={'tel:1855-3631'}>1855-3631</a>, 이메일{' '}
              <a href={'mailto:cs@datau.co.kr'}>cs@datau.co.kr</a>
            </li>
            <li>
              서비스 홈페이지: <a href={'https://www.familycare.ai'}>https://www.familycare.ai</a>
            </li>
            <li>(주)데이터유니버스 서울 영등포구 여의대로 70</li>
            <li>사업자등록번호: 382-86-1230 / 통신판매업신고: 제2020-서울영등포-1315호</li>
          </>
        )
      case 'ktfamilybox_e01':
        return (
          <>
            <li>본 이벤트 및 휴대폰가족보호 서비스는 (주)데이터유니버스에서 제공합니다.</li>
            <li>본 이벤트는 만 19세 이상 KT 고객님만 응모할 수 있습니다.</li>
            <li>
              본 이벤트의 경품의 경우, 휴대폰가족보호 서비스에 유료로 신규 가입한 고객에 한하여
              지급됩니다.
            </li>
            <li>
              본 이벤트의 경품으로 지급된 쿠폰을 기한 내에 미등록하여 이용 기한이 만료된 경우
              보상하지 않습니다.
            </li>
            <li>본 이벤트는 휴대폰 번호당 1회 응모할 수 있습니다.</li>
            <li>
              본 이벤트는 KT 및 운영사의 사정에 따라 별도의 안내없이 변경 및 중단될 수 있습니다.
            </li>
            <li>경품 지급일 이전에 서비스를 해지할 경우 경품 지급 대상에서 제외됩니다.</li>
            <li>
              문자메시지(MMS) 수신이 되지 않은 휴대폰인 경우 모바일 쿠폰을 지급받을 수 없으며, 다시
              지급해드리지 않습니다.
            </li>
            <li>
              본 서비스는 청약철회가 불가능한 상품입니다.(전자상거래 등에서의 소비자보호에 관한 법률
              제17조 2항 5호에 따라 디지털 콘텐츠의 제공이 개시된 경우 청약철회를 제공하지
              않습니다.)
            </li>
            <li>
              본 이벤트는 만 19세 이상이 아니거나, 휴대폰 정지 혹은 이용중인 스마트폰 OS에 따라
              참여에 제한이 있을 수 있습니다.
            </li>
            <li className="important">
              서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.
            </li>
            <li>
                미아/치매노인찾기 보상 보험은 가입 다음날 0시부터 제공되며, 미아찾기/치매노인찾기 각각 담보당 서비스 이용자 1인 1사고당 보험한도액은 200만원입니다. 보험금 지급 시 각 담보당 자기부담금(10만원)이 발생하며, 증권상 최대보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.
            </li>
            <li>
                본 서비스는 스마트폰(안드로이드7.0 이상) 사용자만 이용가능합니다.
            </li>
            <li>
              미성년자의 경우, 법정대리인 동의 없는 가입 시 미성년자 본인 또는 법정대리인이 계약을
              취소할 수 있습니다.
            </li>
            <li>
              문의 : 고객센터 <a href={'tel:1855-3631'}>1855-3631</a>, 이메일 <a href={'mailto:cs@datau.co.kr'}>cs@datau.co.kr</a>
            </li>
            <li>
              서비스 홈페이지: <a href={'https://www.familycare.ai'}>https://www.familycare.ai</a>
            </li>
            <li>(주)데이터유니버스 서울 영등포구 여의대로 70</li>
            <li>사업자등록번호: 382-86-1230 / 통신판매업신고: 제2020-서울영등포-1315호</li>
          </>
        )
      case 'ktpass_01':
      case 'ktpass_02':
      case 'ktpass_03':
        return (
          <>
            <li>본 이벤트 및 휴대폰가족보호 서비스는 (주)데이터유니버스에서 제공합니다.</li>
            <li className="important">
              서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.
            </li>
            <li>미아/치매노인찾기 보상 보험은 가입 다음날 0시부터 제공되며, 미아찾기/치매노인찾기 각각 담보당 서비스 이용자 1인 1사고당 보험한도액은 200만원입니다. 보험금 지급 시 각 담보당 자기부담금(10만원)이 발생하며, 증권상 최대보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.</li>
            <li>
              본 서비스의 원활한 이용을 위해 앱을 설치해주세요.(스마트폰 안드로이드 7.0이상 지원)
            </li>
            <li>
              본 서비스는 청약철회가 불가능한 상품입니다.(전자상거래 등에서의 소비자보호에 관한 법률
              제17조 2항 5호에 따라 디지털 콘텐츠의 제공이 개시된 경우 청약철회를 제공하지
              않습니다.)
            </li>
            <li>
              본 이벤트는 만 20세 이상이 아니거나, 휴대폰 정지 혹은 이용중인 스마트폰 OS에 따라
              참여에 제한이 있을 수 있습니다.
            </li>
            <li>
              본 이벤트의 경품의 경우, 휴대폰가족보호 서비스에 유료로 신규 가입한 고객에 한하여
              지급됩니다.
            </li>
            <li>
              본 이벤트는 경품 추첨일 이전에 서비스를 해지하시는 경우 경품이 지급되지 않습니다.
            </li>
            <li>
              본 이벤트의 경품으로 지급된 쿠폰을 기한 내에 미등록하여 이용기한이 만료된 경우
              보상하지 않습니다.
            </li>
            <li>
              본 이벤트로 당첨된 경품이 소비자가 5만원을 초과할 경우, 제세공과금 22%를 당첨자가
              부담하며 제세공과금 처리를 위해 별도의 개인정보를 요청할 수 있습니다. 또한, 추첨 후
              7일 간 총 3회의 전화 혹은 문자를 통한 연락이 연결되지 않을 경우 당첨은 취소 처리되며
              재추첨은 이루어지지 않습니다.
            </li>
            <li>
              본 이벤트에 비정상적, 불법적인 방법으로 참여한 경우, 당첨자 선정에서 제외되거나 당첨이
              취소될 수 있습니다.
            </li>
            <li>본 이벤트는 운영사의 사정에 따라 별도 고지없이 변경 또는 중단될 수 있습니다.</li>
            <li>본 이벤트는 휴대폰번호 기준 1회만 참여 가능합니다.</li>
            <li>
              문의 : 고객센터 <a href={'tel:1855-3631'}>1855-3631</a>, 이메일{' '}
              <a href={'mailto:cs@datau.co.kr'}>cs@datau.co.kr</a>
            </li>
            <li>
              서비스 홈페이지: <a href={'https://www.familycare.ai'}>https://www.familycare.ai</a>
            </li>
            <li>(주)데이터유니버스 서울 영등포구 여의대로 70</li>
            <li>사업자등록번호: 382-86-1230 / 통신판매업신고: 제2020-서울영등포-1315호</li>
          </>
        )
      default:
        return (
          <>
            <li>본 서비스는 청약철회가 불가능한 상품입니다.</li>
            <li className="important">
              서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.
            </li>
            <li>미아/치매노인찾기 보상 보험은 가입 다음날 0시부터 제공되며, 미아찾기/치매노인찾기 각각 담보당 서비스 이용자 1인 1사고당 보험한도액은 200만원입니다. 보험금 지급 시 각 담보당 자기부담금(10만원)이 발생하며, 증권상 최대보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.</li>
            <li>본 서비스는 스마트폰(안드로이드7.0 이상) 사용자만 이용가능합니다.</li>
            <li>
              미성년자의 경우, 법정대리인 동의 없는 가입 시 미성년자 본인 또는 법정대리인이 계약을
              취소할 수 있습니다.
            </li>
            <li>본 서비스는 ㈜데이터유니버스가 운영합니다. 고객센터 1855-3631(이용, 해지문의)</li>
            <li>
              홈페이지 주소 :<span onClick={homepage}> https://www.familycare.ai</span>
            </li>
            <li>이메일 : cs@datau.co.kr</li>
            <li>
              사업자등록번호 : 382-86-01230,
              <span onClick={committee}>통신판매업신고</span> : 제2020-서울영등포-1315호
            </li>
          </>
        )
    }
  }
  return (
    <Rop01FooterWrap color={color} backgroundColor={backgroundColor}>
      <section>
        <div>
          <ul>{pcode && pCodeLiContents(pcode)}</ul>
        </div>
      </section>
    </Rop01FooterWrap>
  )
}
export default Footer
